import { createElement, CSSProperties } from 'react'
import icons from '../../icons/index.js'
import { Color, colors } from '../../tokens/colors.js'

export const ICONS = Object.keys(icons)

export type IconProps = {
  variant: keyof typeof icons
  size?: 'regular' | 'small'
  style?: CSSProperties
  color?: 'inherit' | Color
  scaleChevrons?: boolean
}

export function Icon({
  variant,
  size = 'regular',
  style = {},
  color = 'neutral100',
  scaleChevrons,
}: IconProps) {
  const El = icons[variant]

  if (size === 'regular') {
    style = style || {}
    style.height = 24
    style.width = 24
  } else if (size === 'small') {
    style = style || {}
    style.height = 16
    style.width = 16
  }

  style.flexShrink ??= 0

  let viewBox = '0 0 24 24'
  // tiny chevrons are treated differently
  // because they are smaller than the other
  // icons. But in case of a very small button
  // they should not be scaled down
  if (
    scaleChevrons &&
    (variant === 'tiny-chevron-down' ||
      variant === 'tiny-chevron-up' ||
      variant === 'tiny-chevron-left' ||
      variant === 'tiny-chevron-right')
  ) {
    viewBox = '4 4 16 16'
  }

  return El ? (
    <svg
      viewBox={viewBox}
      style={{
        color: color === 'inherit' ? 'inherit' : colors[color],
        ...style,
      }}
    >
      {createElement(El)}
    </svg>
  ) : null
}
